import React from "react";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loginLottie from "../static/login-asset/wm-login-lottie.json";
import { Link } from "react-router-dom";
import Logo from "../common-components/Logo";
import { AppConstants } from "../constants";

type ForgotPasswordFormInputs = {
  email: string;
};

const ForgotPassword: React.FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
    reset,
  } = useForm<ForgotPasswordFormInputs>({
    mode: "onChange",
  });

  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const currentYear = new Date().getFullYear();



  const onSubmit = async (data: ForgotPasswordFormInputs) => {
    const encodedFormData = new URLSearchParams();
    encodedFormData.append("action", "forgotPasswordRequest");
    encodedFormData.append("j_username", data.email);
    encodedFormData.append("regButton", "Send");
    encodedFormData.append("wm_captchaId", "");

    const response = await fetch(
      window.location.origin + "/login/forgotpassword",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: encodedFormData.toString(),
      },
    );

    const outputData = await response.json();
    reset();

    if (response.status === 200 && outputData) {
      const redirectUrl = outputData?.redirectUrl || null;
      if (redirectUrl) {
        navigate(redirectUrl);
      }
    } else {
      setErrorMessage(outputData?.errorMessage || "");
    }
  };



  return (
    <div className="login-container">
      <div className="row">
        <div className="row">
          <div className="login-left-section col-xs-12 col-sm-5 col-md-5 col-lg-5">
            <div className="login-content">
              <Logo />
              <form
                id="forgotPasswordForm"
                name="forgotpassword"
                className="form-container login"
                onSubmit={handleSubmit(onSubmit)}
                noValidate
              >
                <div className="form-title">
                  <h1>Forgot Password</h1>
                </div>

                <input
                  type="hidden"
                  name="action"
                  value="forgotPasswordRequest"
                />
                <input className="hide" id="captchaId" name="wm_captchaId" />

                <div className="form-row" id="formrow">
                  {errorMessage && (
                    <p
                      className="help-block validation alert alert-danger serverError"
                      id="errorMessageDisplay"
                    >
                      {errorMessage}
                    </p>
                  )}

                  <div className="row">
                    <div
                      className={`control-group ${errors.email ? "error" : touchedFields?.email ? "success" : ""}`}
                    >
                      <input
                        className="inputText"
                        type="email"
                        maxLength={80}
                        id="email"
                        placeholder="Email"
                        {...register("email", {
                          required: "Please enter a valid email address",
                          pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "Not a valid email address",
                          },
                        })}
                        aria-invalid={errors.email ? "true" : "false"}
                      />
                      {errors.email && (
                        <p className="help-block validation alert alert-danger">
                          {errors.email.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12 no-padding">
                      <button
                        type="submit"
                        className="btn btn-submit pull-right col-xs-12 col-sm-12"
                        value="Send"
                        name="regButton"
                        id="formSubmit"
                      >
                        Send
                      </button>
                    </div>
                    <div className="col-sm-12 no-padding">
                      <Link to={"/"} className="btn btn-block ">
                        Login
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <p className="copyright-text">
              © {currentYear} WaveMaker. All Rights Reserved
            </p>
          </div>
          <div className="login-right-section col-xs-12 col-sm-7 col-md-7 col-lg-7">
            <div className="right-content-wrapper">
              <h3 className="right-section-title">
                {AppConstants.CAROUSELTITLE}
              </h3>
              <Lottie
                animationData={loginLottie}
                loop={true}
                className="lottie-animation"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
